import { useDispatch, useSelector } from 'react-redux';
import { selectIsEktacoUser, selectIsSuper, selectIsSuperRightsActive } from 'src/store/selectors/userInfo';
import { useCallback, useEffect } from 'react';
import { setSuperRights } from 'src/store/actions/userActions';
import { isNil } from 'ramda';
const STORE_KEY = 'SUPER_RIGHTS';
const DEFAULT_VALUE = true;
const getFromStore = () => {
    const value = localStorage.getItem(STORE_KEY);
    return JSON.parse(value);
};
const setInStore = (value) => {
    localStorage.setItem(STORE_KEY, JSON.stringify(value));
};
function useSuperRights(initialize) {
    const dispatch = useDispatch();
    const isSuperEnabled = useSelector(selectIsSuperRightsActive);
    const isEktacoUser = useSelector(selectIsEktacoUser);
    const isSuper = useSelector(selectIsSuper);
    useEffect(() => {
        if (initialize && isEktacoUser) {
            const value = getFromStore();
            if (isNil(value))
                setInStore(DEFAULT_VALUE);
            dispatch(setSuperRights(value ?? DEFAULT_VALUE));
        }
    }, [dispatch, initialize, isEktacoUser]);
    const toggleSuper = useCallback((forcedValue) => {
        const value = forcedValue ?? !isSuperEnabled;
        setInStore(value);
        dispatch(setSuperRights(value));
    }, [dispatch, isSuperEnabled]);
    return {
        isSuperEnabled,
        isEktacoUser,
        isSuper,
        toggleSuper
    };
}
export default useSuperRights;
